import { render, staticRenderFns } from "./SharePriceMetricsPool.vue?vue&type=template&id=61b048ef&scoped=true&"
import script from "./SharePriceMetricsPool.vue?vue&type=script&lang=js&"
export * from "./SharePriceMetricsPool.vue?vue&type=script&lang=js&"
import style0 from "./SharePriceMetricsPool.vue?vue&type=style&index=0&id=61b048ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b048ef",
  null
  
)

export default component.exports